export enum StudentLevelEnum {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    SENIOR = "senior"
}
